import React from "react";
import CommunityContent from "../../../components/CommunityContent";
import { ActionButton, SubmitButton } from "../../../styles/communityCommon";
import { CommunityHomeCss } from "../../../styles/communityHome";

const CommunityLanding = (props) => {
  const logOutHandler = () => {
    let obj = {
      token: "",
      userId: "",
    };
    props.onChange(obj);
  };

  return (
    <>
      <CommunityHomeCss />
      <div className="community-parent-container">
        <div className="community-header">
          <div className="community-header-text">
            Hello! Welcome to the Community page of Dev-AI.
          </div>
          <div>
            <ActionButton onClick={logOutHandler}>Logout</ActionButton>
          </div>
        </div>

        <div className="community-content">
          <CommunityContent />
        </div>
      </div>
    </>
  );
};

export default CommunityLanding;
